import { ColorPicker, Upload, Typography, Modal, Row, Col, Button, DatePicker, Popover, Card, Input, Popconfirm, Checkbox, Empty } from 'antd';
import React, { useEffect, useState, useRef } from 'react';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { ExclamationCircleFilled, PlusOutlined, SettingFilled } from '@ant-design/icons';
import JoditEditor from "jodit-react";
import dayjs from 'dayjs';
import axios from 'axios';
import AdminModal from "./AdminModal";
const { TextArea } = Input;
const { confirm } = Modal;
const NewsModal = (props) => {
    const [more_information, set_more_information] = useState(false);
    const editor = useRef(null);
    const config = {
        readonly: false, // all options from https://xdsoft.net/jodit/doc/
        uploader: {
            insertImageAsBase64URI: true,
            // url: `${axios.defaults.baseURL}/api/literacy/admin/editor/file`
        },
        language: 'zh_tw'
    };
    const [check, setCheck] = useState(false);
    const [schedule_date, set_schedule_date] = useState(undefined);
    const [blog_id, set_blog_id] = useState(null);
    useEffect(() => {
        // console.log(props.editcard)
        setCheck(false);
        if (props.editcard['annoucement_time'] != undefined) {
            setCheck(true)
            set_schedule_date(props.editcard['annoucement_time']);
        } else {
            set_schedule_date(null);
        }
        if (JSON.stringify(props.editcard) != '{}') {
            set_blog_id(props.editcard.blog_id);
            // if (props.editcard['file_id'] != undefined) {
            //     get_picture();
            // }
        } else {
            set_blog_id('');

        }
    }, [props.editcard])
    const handleOnChangeTop = (e) => {
        // console.log(e.target.checked);
        props.setEditCard(prev => {
            return (
                {
                    ...prev,
                    top: e.target.checked,
                }
            )
        })
    }
    useEffect(() => {
        set_more_information(false);
        if (props.editcard['more_content'] != null || undefined || "") {
            set_more_information(true);
        }
    }, [props.editcard['more_content']])
    return (
        <>
            <AdminModal
                {...props}
                title={(<>
                    <Col style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 53, left: 32 }} >{props.title}</Col>
                    <Col>
                        {props.edit ?
                            <>
                                <Popconfirm
                                    placement="topRight"
                                    title='確定刪除嗎？'
                                    onConfirm={e => props.handleDelete(props.editcard['blog_id'])}
                                    okText="確定"
                                    cancelText="取消"
                                >
                                    <Button style={{ backgroundColor: '#FCF5F6' }} >
                                        <Row>
                                            <Col span={6}>
                                                <img width="80%" src='/cram_school/trashicon.png'></img>
                                            </Col>
                                            <Col span={18}>
                                                <span>刪除貼文</span>
                                            </Col>
                                        </Row>
                                    </Button>
                                </Popconfirm>
                            </> :
                            <>
                            </>
                        }
                    </Col>
                </>)}
                uploads
            >
                <Row gutter={[8, 8]} align={'middle'}>
                    <Col span={6}>文章標題</Col>
                    <Col span={18}>
                        <Input placeholder={'請輸入文章標題'} value={props.editcard['title']}
                            onChange={e => props.setEditCard(prev => {
                                return (
                                    {
                                        ...prev,
                                        title: e.target.value,
                                    }
                                )
                            })}
                            autoComplete="off" />
                    </Col>
                    <Col span={6}></Col>
                    <Col span={18}>
                        <Checkbox checked={check} onChange={e => setCheck(!check)}>排程發佈</Checkbox>
                        {check || props.editcard['annoucement_time'] != undefined ?
                            <DatePicker
                                // value={props.editcard['annoucement_time'] != undefined ? dayjs(null) : dayjs(schedule_date, 'YYYY-MM-DD')}
                                value={schedule_date != '' && schedule_date != undefined && schedule_date != null ? dayjs(schedule_date, 'YYYY-MM-DD') : null}
                                onChange={(date, dateString) => props.setEditCard(prev => {
                                    return (
                                        {
                                            ...prev,
                                            annoucement_time: dateString,
                                        }
                                    )
                                })} />
                            : null
                        }
                    </Col>
                    <Col span={6}></Col>
                    <Col span={18}>
                        <Checkbox checked={props.editcard?.top} onChange={handleOnChangeTop}>文章置頂</Checkbox>
                    </Col>
                    <Col span={6}>內文說明</Col>
                    <Col span={18}>
                        <TextArea rows={4} placeholder="請輸入內容" value={props.editcard['content']}
                            onChange={e => props.setEditCard(prev => {
                                return (
                                    {
                                        ...prev,
                                        content: e.target.value,
                                    }
                                )
                            })} />
                    </Col>
                    <Col span={6}></Col>
                    <Col span={18}>
                        <Checkbox checked={more_information} onChange={e => set_more_information(!more_information)}>更多內容</Checkbox>
                    </Col>
                    {
                        more_information ? <>
                            <JoditEditor
                                ref={editor}
                                value={props.editcard.more_content}
                                config={config}
                                tabIndex={1} // tabIndex of textarea
                                onBlur={value => props.setEditCard(prev => {
                                    return (
                                        {
                                            ...prev,
                                            more_content: value
                                        }
                                    )
                                })}
                                height={500}
                                allowResizeX={true}
                                allowResizeY={true}
                            />
                        </> : null
                    }
                    <Col span={6}>背景顏色</Col>
                    <Col span={18}>
                        <ColorPicker
                            format={'hex'}
                            value={props.editcard.background_color}
                            onChange={color =>
                                props.setEditCard((pre) => {
                                    return (
                                        {
                                            ...pre,
                                            background_color: `#${color.metaColor.toHex()}`,
                                        }
                                    )
                                })
                            }></ColorPicker>
                    </Col>
                    <Col span={6}>文字顏色</Col>
                    <Col span={18}>
                        <ColorPicker
                            format={'hex'}
                            value={props.editcard.font_color}
                            onChange={color =>
                                props.setEditCard((pre) => {
                                    return (
                                        {
                                            ...pre,
                                            font_color: `#${color.metaColor.toHex()}`,
                                        }
                                    )
                                })
                            }></ColorPicker>
                    </Col>
                    <Col span={8}>照片背景顏色</Col>
                    <Col span={16}>
                        <ColorPicker
                            format={'hex'}
                            value={props.editcard.font_color}
                            onChange={color =>
                                props.setEditCard((pre) => {
                                    return (
                                        {
                                            ...pre,
                                            font_color: `#${color.metaColor.toHex()}`,
                                        }
                                    )
                                })
                            }></ColorPicker>
                    </Col>
                </Row>
            </AdminModal >
        </>
    )

}
export default NewsModal;